import { ClassProvider } from '@angular/core';

import { NEVER, Observable } from 'rxjs';

export abstract class WysiwygUploader {
  public abstract upload(data: any): Observable<any>;
}

export class NoopWysiwygUploader implements WysiwygUploader {
  public upload(data: any): Observable<any> {
    console.warn(`[NoopWysiwygUploader] Noop`);
    return NEVER;
  }
}

export interface WysiwygUploaderProvider extends ClassProvider {
  provide: typeof WysiwygUploader;
}

export type TrackableFileType = 'image' | 'other';
export type Base64Image = { id: string; base64: string };

export type TrackableFile = {
  id: string;
  url: string;
  file: File;
  type: TrackableFileType;
  name?: string;
  error?: any;
};

export type TrackableImageFile = TrackableFile & { type: 'image'; width: number };
